import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-encounter-type-eligibilities-explainer',
    templateUrl: './encounter-type-eligibilities-explainer.component.html',
    styleUrls: ['./encounter-type-eligibilities-explainer.component.scss'],
    imports: [MatIcon]
})
export class EncounterTypeEligibilitiesExplainerComponent {
  @Input() expanded = true;

  @Output() expandOrCollapse = new EventEmitter<boolean>();

  onExpandOrCollapseClick(expanded: boolean) {
    this.expanded = expanded;
    this.expandOrCollapse.emit(expanded);
  }
}
